
export let client  = {
  put: function(fileName, file) {
    console.log('oss put', fileName, file)
    return new Promise((resolve, reject) => {
      // 创建 FormData 对象封装文件
      const formData = new FormData();
      formData.append('file', file, fileName);

      // 创建 XHR 对象
      const xhr = new XMLHttpRequest();

      // 上传完成处理
      xhr.onload = function() {
        if (xhr.status === 200) {
          resolve({
            res: {
              status: xhr.status,
              msg: JSON.parse(xhr.response).msg
            },
            url: JSON.parse(xhr.response).data,
            name: fileName,
          })
        } else {
          console.error('上传失败！')
          reject(JSON.parse(xhr.response).msg)
        }
      };

      // 错误处理
      xhr.onerror = function() {
        reject('上传失败！')
        console.error('上传失败！')
      };

      // 配置并发送请求
      xhr.open('POST', 'http://fjplapi.a6edu.com/admin-api/infra/file/upload'); // 替换为实际接口
      xhr.setRequestHeader('Authorization', 'Bearer 1');
      xhr.setRequestHeader('tenant-id', '1');
      xhr.send(formData);
    })
  },
}